import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class InfiSpotlightAnalytics extends BaseInvitePeopleAnalytics {
	spotlightViewed() {
		this.fireScreen({
			name: AnalyticsActionSubject.INFI_SPOTLIGHT,
		});
	}

	spotlightDismissed() {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.INFI_SPOTLIGHT,
			action: AnalyticsAction.CLOSED,
		});
	}
}
